import { ref } from 'vue';

const getProjects = () => {
    const projects_error = ref(null);
    const projects = ref(null);

    const loadProjects = async (filters = null) => {
      try {
        var params = [];

        if (filters) {
            for (const filter of filters) {
              params.push(filter);
            }
        }

        let data = await fetch("/api/experienceprojects?" + new URLSearchParams(params));

        if (!data.ok) {
          throw Error("Can't load data");
        }

        projects.value = await data.json();

        //console.log('projects', projects.value);
      } catch (err) {
        projects_error.value = err.message;
      }
    };

    return { projects, projects_error, loadProjects};
}

export default getProjects;
